import { useNavigate } from "react-router-dom"
import heroAtrasado from "../../assets/images/hero_atrasado.png"
import heroDefault from "../../assets/images/hero_image.png"
import heroRelembrar from "../../assets/images/hero_relembrar.png"
import graphicIcon from "../../assets/images/icons/graphic.svg"
import pencilIcon from "../../assets/images/icons/pencil.svg"
import testTubeIcon from "../../assets/images/icons/test-tube.svg"
import whiteFolderIcon from "../../assets/images/icons/white-folder.svg"
import whitePasteIcon from "../../assets/images/icons/white-paste.svg"
import Button from "../button/button"
import {monthNames} from "../../mocks/consts";
import "./index.scss"
import {eventTag} from "../../services/utils";

const planningSteps = [
  "Nome do Planejamento",
  "Média Mensal",
  "Custos Indiretos Variáveis",
  "Investimento Total",
  "Prazos de Recebimento",
  "Prazos de Pagamento",
  "Giro de Estoque",
  "Capacidade de Pagamento",
]

const completedNextSteps = [
  {
    id: "monitoring",
    title: "Comece a monitorar",
    description: "Acompanhe mensalmente os resultados da sua empresa para apoiar sua gestão.",
    icon: pencilIcon,
  },
  {
    id: "comparison-lab",
    title: "Explore o laboratório de Comparação",
    description: "Acompanhe mensalmente os resultados da sua empresa para apoiar sua gestão.",
    icon: testTubeIcon,
  },
]

const monitoringReminderSteps = [
  {
    id: "graphic",
    text: "Acompanhe a evolução das suas métricas ao longo do tempo",
    icon: graphicIcon,
  },
  {
    id: "paste",
    text: "Entenda a saúde financeira do seu negócio",
    icon: whitePasteIcon,
  },
  {
    id: "folder",
    text: "Saiba o melhor momento para buscar crédito",
    icon: whiteFolderIcon,
    iconClassName: "home-hero__reminder-step-icon-image--folder",
  },
]

const heroImages = {
  "no-plannings": heroDefault,
  "in-progress": heroDefault,
  "completed-no-monitoring": heroDefault,
  "monitoring-overdue": heroAtrasado,
  "monitoring-reminder": heroRelembrar,
}

const heroContent = {
  "no-plannings": {
    eyebrow: "Você ainda não tem planejamentos",
    title: "Comece já!",
    buttonLabel: "Criar Novo Planejamento",
    showProgress: false,
    stepsTitle: "Conheça as etapas do processo",
  },
  "in-progress": {
    eyebrow: "Você tem planejamentos",
    title: "Em Andamento",
    buttonLabel: "Continuar Planejamento",
    showProgress: true,
    stepsTitle: "Próximos Passos",
  },
  "completed-no-monitoring": {
    eyebrow: "Seus planejamentos estão",
    title: "Concluídos",
    buttonLabel: "Começar Monitoramento",
    showProgress: true,
    stepsTitle: "Próximos Passos",
  },
  "monitoring-overdue": {
    eyebrow: "Você já tem monitoramento",
    title: "Atrasado",
    buttonLabel: "Preencher Monitoramento",
    showProgress: false,
    stepsTitle: "Próximos Passos",
    reminderMonth: "Abril 2026",
    reminderLeadStrong: "Ops!",
    reminderLeadText: "Você tem monitoramentos mensais atrasados.",
    reminderTitle: "Mantenha seus dados sempre atualizados",
    reminderDescription: "Tenha uma visão clara do seu negócio e tome decisões com base em dados confiáveis.",
  },
  "monitoring-reminder": {
    eyebrow: "Você já tem monitoramento",
    title: "Relembrar",
    buttonLabel: "Preencher Monitoramento",
    showProgress: false,
    stepsTitle: "Próximos Passos",
    reminderMonth: "Abril 2026",
    reminderLeadStrong: "Não se esqueça!",
    reminderLeadText: "Você ainda não preencheu seu monitoramento mensal.",
    reminderTitle: "Mantenha seus dados sempre atualizados",
    reminderDescription: "Tenha uma visão clara do seu negócio e tome decisões com base em dados confiáveis.",
  },
}

const reminderAnimationBaseClass = "animate__animated animate__fadeIn"
const reminderAnimationDelayStep = 200

const HomeHero = ({
  hasPlannings,
  heroState = "no-plannings",
  progressPercentage = 0,
  monitoringMonth = null,
  monitoringYear = null,
  event,
  hasActiveAd = false,
}) => {
  const navigate = useNavigate()
  const resolvedHeroState = hasPlannings ? heroState : "no-plannings"
  const heroImage = heroImages[resolvedHeroState] || heroDefault
  const content = heroContent[resolvedHeroState] || heroContent["no-plannings"]
  const normalizedProgressPercentage = resolvedHeroState === "completed-no-monitoring"
    ? 100
    : Math.max(0, Math.min(100, Number(progressPercentage) || 0))
  const completedSteps = Math.min(
    planningSteps.length,
    Math.floor(normalizedProgressPercentage / 11)
  )
  const remainingSteps = hasPlannings
    ? planningSteps.slice(completedSteps)
    : planningSteps
  const startIndex = hasPlannings ? completedSteps + 1 : 1
  const isCompletedWithoutMonitoring = resolvedHeroState === "completed-no-monitoring"
  const isMonitoringState = ["monitoring-reminder", "monitoring-overdue"].includes(resolvedHeroState)
  const isMonitoringOverdue = resolvedHeroState === "monitoring-overdue"
  const ctaRoute = isMonitoringState ? "/monitoramento" : "/planejamentos"
  const monthLabel = monitoringMonth && monitoringYear
    ? `${monthNames[monitoringMonth - 1] || ""} ${monitoringYear}`.trim()
    : content.reminderMonth
  const getReminderAnimationStyle = (stepIndex) => ({
    animationDelay: `${stepIndex * reminderAnimationDelayStep}ms`,
  })

  return (
    <section className={`home-hero ${hasActiveAd ? "home-hero--with-ad" : ""}`}>
      <div className="home-hero__content">
        <div className="home-hero__copy">
          {isMonitoringState ? (
            <>
              <p
                className={`${reminderAnimationBaseClass} monitoring-lead ${isMonitoringOverdue ? "monitoring-lead--overdue" : ""}`}
                style={getReminderAnimationStyle(0)}
              >
                <strong>{content.reminderLeadStrong}</strong> {content.reminderLeadText}
              </p>
              <div className={`home-hero__month-badge ${isMonitoringOverdue ? "home-hero__month-badge--overdue" : ""}`}>
                {monthLabel}
              </div>
              <h4
                className={`${reminderAnimationBaseClass} reminder-title`}
                style={getReminderAnimationStyle(1)}
              >
                {content.reminderTitle}
              </h4>
              <span
                className={`${reminderAnimationBaseClass} reminder-description`}
                style={getReminderAnimationStyle(2)}
              >
                {content.reminderDescription}
              </span>

              <div className="home-hero__reminder-steps">
                {monitoringReminderSteps.map((step, index) => (
                  <div
                    className={`${reminderAnimationBaseClass} home-hero__reminder-step`}
                    key={step.id}
                    style={getReminderAnimationStyle(index + 3)}
                  >
                    <span className="home-hero__reminder-step-icon">
                      <img
                        className={step.iconClassName || ""}
                        src={step.icon}
                        alt=""
                        aria-hidden="true"
                      />
                    </span>
                    <span className="home-hero__reminder-step-text">{step.text}</span>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              <p>{content.eyebrow}</p>

              <h3>{content.title}</h3>

              {content.showProgress && (
                <div className="home-hero__progress">
                  <div className="home-hero__progress-track">
                    <span style={{ width: `${normalizedProgressPercentage}%` }} />
                  </div>
                  <span className="home-hero__progress-label">
                    {normalizedProgressPercentage.toFixed(0)}% Concluído
                  </span>
                </div>
              )}

              <h4>{content.stepsTitle}</h4>

              {isCompletedWithoutMonitoring ? (
                <div className="home-hero__step-cards">
                  {completedNextSteps.map((step) => (
                    <div className="home-hero__step-card" key={step.id}>
                      <div className={`home-hero__step-card-icon home-hero__step-card-icon--${step.id}`}>
                        <img src={step.icon} alt="" aria-hidden="true" />
                      </div>
                      <div className="home-hero__step-card-copy">
                        <strong>{step.title}</strong>
                        <span>{step.description}</span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="home-hero__steps">
                  {remainingSteps.map((step, index) => (
                    <div className="home-hero__step" key={step}>
                      <span className="home-hero__step-number">{startIndex + index}</span>
                      <span className="home-hero__step-text">
                        Preencher <strong>{step}</strong>
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          <div className="home-hero__actions">
            <Button
              isPrimary
              maxWidth="244px"
              callback={() => {
                navigate(ctaRoute)
                eventTag(event?.name, event?.category, event?.action, content?.buttonLabel)
              }}
            >
              {content.buttonLabel}
            </Button>
          </div>
        </div>

        {!hasActiveAd ? (
          <picture className={`home-hero__media home-hero__media--${resolvedHeroState}`}>
            <img
              className={`home-hero__image home-hero__image--${resolvedHeroState}`}
              src={heroImage}
              alt="Planejamento financeiro"
              loading="lazy"
            />
          </picture>
        ) : null}
      </div>
    </section>
  )
}

export default HomeHero
